$(function () {
    var reviewSearchFormChangeBufferTimeout;
    var reviewSearchTooltipTimeout;

    $('#review-search-form').on('change', function() {
        $form = $(this);
        var $button = $form.find('button[type=submit]');
        clearTimeout(reviewSearchFormChangeBufferTimeout);
        reviewSearchFormChangeBufferTimeout = setTimeout(function() {
            $button.removeClass('hidden');

            $.ajax({
                url: $form.data('filterurl'),
                data: $form.serialize(),
                success: function(response) {
                    $button.tooltip('destroy');
                    var tooltipText = '';
                    var count = response.count;

                    if (count > 0) {
                        tooltipText = Text.plural(count, ['Найден', 'Найдено', 'Найдено']);

                        tooltipText += ' ' + count + ' ' + Text.plural(count, ['объект', 'объекта', 'объектов']);
                    } else {
                        tooltipText = 'Ничего не найдено';
                    }

                    $button.tooltip({
                        trigger: 'manual',
                        html: true,
                        title: tooltipText,
                        placement: 'top'
                    }).tooltip('show');

                    if(response.tourObjects) {
                        var $tourObjectSelect2 = $('#tourObject-select');

                        $tourObjectSelect2.select2('destroy');
                        $tourObjectSelect2.html(response.tourObjects);
                        initSelect2ForTourObject();
                    }

                    clearTimeout(reviewSearchTooltipTimeout);
                    reviewSearchTooltipTimeout = setTimeout(function() {
                        $button.tooltip('destroy');
                    }, 5000);
                }
            });

        }, 400);
    });

    if($('#tourObject-select').length > 0) {
        initSelect2ForTourObject();
    }

    function initSelect2ForTourObject() {
        $('#tourObject-select').select2({
            placeholder: 'Выберите объект',
            width: '100%'
        });
    }

    $('.review .expand').on('click', function(e) {
        e.preventDefault();
        $(this).parents('.review-content').find('.expanded-content').toggleClass('hidden');
        $(this).parents('.review-content').find('.short-content').toggleClass('hidden');

        var toggleText = $(this).data('toggletext');
        var text = $(this).text();

        $(this).data('toggletext', text);
        $(this).text(toggleText);

        return false;
    });

});
